module.exports = __webpack_public_path__ + "static/media/img2.1fe1ed4c.jpg";